export interface PasswordStrength {
  score: number;
  label: string;
  color: string;
}

export const calculatePasswordStrength = (
  password: string,
): PasswordStrength => {
  let score = 0;

  if (password.length >= 8) score += 1;
  if (password.length >= 12) score += 1;
  if (/[a-z]/.test(password) && /[A-Z]/.test(password)) score += 1;
  if (/\d/.test(password)) score += 1;
  if (/[^a-zA-Z0-9]/.test(password)) score += 1;

  if (score <= 1) {
    return { score, label: "Fraca", color: "var(--destructive)" };
  }

  if (score <= 3) {
    return { score, label: "Média", color: "#f59e0b" };
  }

  return { score, label: "Forte", color: "#10b981" };
};

export const generatePassword = (): string => {
  const length = 16;
  const lowercase = "abcdefghijklmnopqrstuvwxyz";
  const uppercase = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
  const numbers = "0123456789";
  const symbols = "!@#$%&*-_+=";

  const allChars = lowercase + uppercase + numbers + symbols;
  let password = "";

  password += lowercase[Math.floor(Math.random() * lowercase.length)];
  password += uppercase[Math.floor(Math.random() * uppercase.length)];
  password += numbers[Math.floor(Math.random() * numbers.length)];
  password += symbols[Math.floor(Math.random() * symbols.length)];

  for (let index = password.length; index < length; index += 1) {
    password += allChars[Math.floor(Math.random() * allChars.length)];
  }

  return password
    .split("")
    .sort(() => Math.random() - 0.5)
    .join("");
};
